import { useEffect } from "react";
import Lenis from "lenis";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Services from "@/components/site/Services";
import TeamEstimate from "@/components/site/TeamEstimate";
import ContactSection from "@/components/site/ContactSection";
import TalentPool from "@/components/site/TalentPool";
import Process from "@/components/site/Process";
import Packages from "@/components/site/Packages";
import TeamSection from "@/components/site/TeamSection";
import Testimonials from "@/components/site/Testimonials";
import TrustedBy from "@/components/site/TrustedBy";
import Footer, { FooterCta, ChatBubble } from "@/components/site/Footer";
import BookingModal from "@/components/site/BookingModal";
import { SiteProvider, useSite } from "@/context/SiteContext";
import { trackVisit } from "@/lib/api";

function Site() {
  useEffect(() => {
    trackVisit();
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (t) => { lenis.raf(t); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);

  return (
    <div className="bg-[#0A1628] min-h-screen">
      <Navbar />
      <Hero />
      <Services />
      <TrustedBy />
      <TeamEstimate />
      <TalentPool />
      <Process />
      <Packages />
      <TeamSection />
      <Testimonials />
      <ContactSection />
      <FooterCta />
      <Footer />
      <ChatBubble />
      <BookingModal />
    </div>
  );
}

export default function Landing() {
  return (
    <SiteProvider>
      <Site />
    </SiteProvider>
  );
}
